import { LitElement, html, css } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { PropertyValues } from "lit";
import { icons } from "../styles/svg-icons";
import { globalState } from "../lib/globa-state";

@customElement("pl-icon")
export class PlIcon extends LitElement {
    @property({ reflect: true })
    icon: string = "";

    @state()
    svgContent: string = "";

    @state()
    theme: string = "";

    static styles = [
        css`
            :host {
                display: inline-block;
                text-align: center;
                font-family: "FontAwesome";
                color: inherit;
                font-size: inherit;
                position: relative;
                height: 1.3em;
                width: 1.3em;
                overflow: hidden;
                font-weight: inherit;
                font-variant: normal !important;
            }

            :host(.create-category-default) img {
                width: 20px;
                height: 20px;
            }

            :host(.icon-preview) img {
                width: 72px;
                height: 72px;
            }

            :host(.inline) {
                display: contents;
            }

            :host(.inline) div {
                display: inline;
            }

            :host(:not(.inline)) div {
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                margin: auto;
                height: 0;
                line-height: 0;
            }

            :host(.large) {
                font-size: 150% !important;
            }

            :host(.big) {
                font-size: 300% !important;
            }

            :host(.huge) {
                font-size: 500% !important;
            }

            :host(.tiny-tag) img {
                height: 1em;
                width: 1em;
            }

            :host(.item-list-header-icon) {
                height: fit-content;
                width: fit-content;
            }

            :host(.item-list-header-icon) img {
                height: 24px;
                width: 24px;
            }

            img {
                height: 100%;
                width: 100%;
                fill: currentColor;
            }
        `,
    ];

    connectedCallback() {
        super.connectedCallback();
        globalState.subscribe("theme", this.handleGlobalStateChange.bind(this));
        this.theme = globalState.getState("theme"); // Initialize theme value
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        globalState.unsubscribe("theme", this.handleGlobalStateChange.bind(this));
    }

    handleGlobalStateChange() {
        this.theme = globalState.getState("theme");
    }

    updated(changedProperties: PropertyValues) {
        if (changedProperties.has("theme") || changedProperties.has("icon")) {
            this.updateSvg();
        }
    }

    updateSvg() {
        this.svgContent = icons[this.theme as "dark" | "light" | "auto"][this.icon] || "";
    }

    render() {
        if (!this.svgContent.trim()) return html``;
        return html`<img src=${this.svgContent} />`;
    }
}
